export enum ItemWorkType {
  NONE = 1,
  LOCAL = 2,
  REMOTE = 3
}
